import { postApiNoAuth } from "../genericServices";

export async function postInfoPinsa(obj) {
  return await postApiNoAuth('infopinsa', obj)
}